import { IAppState } from '../common/state';
import { getRegionId } from '../utils/geo';
import { MAIN_REGIONS_IDS, SPB_AND_REGION } from 'shared/constants/regions';

export const selectSuburbanBlackFridayBannerUrl = (state: IAppState) => {
  const suburbanBannerUrls = state.config.get<Record<'spb' | 'msk', string>>('suburbanBlackFriday.geoUrls');

  const regionId = getRegionId(state.currentLocation);

  if (!suburbanBannerUrls || !MAIN_REGIONS_IDS.includes(regionId)) {
    return;
  }

  return SPB_AND_REGION.includes(regionId) ? suburbanBannerUrls.spb : suburbanBannerUrls.msk;
};
